import { CalculationType, QualityCriterionType, RiskAssessmentStatus } from '../enums';
import { CalculationInputScreeningData, CaseWorker } from '../common';

export class LocationCalculationDetail {
    public id: string;
    public createdAt: Date;
    public calculationType: CalculationType;
    public compoundName: string;
    public compoundCasNr: string;
    public concentration: number;
    public qualityCriterion: number;
    public qualityCriterionType: QualityCriterionType;
    public excessFactor: number;
    public riskAssessment: RiskAssessmentStatus;
    public calculationModelType: number;
    public hasDegradation: boolean;
    public caseWorker: CaseWorker;
    public latestComment: string;
    public isInProgress: boolean;
    public screeningData: CalculationInputScreeningData;

    public calculationFailed: boolean;
    public calculationFailedErrorMessage: string;

    public constructor(init: Partial<LocationCalculationDetail>) {
        Object.assign(this, init);
    }
}
